import { useEffect } from "react";
import type { RefObject } from "react";
import styles from "./UploadView.module.css";

interface ErrorPopupProps {
  readonly dialogRef: RefObject<HTMLDialogElement>;
  readonly errorMessage: string;
  readonly detailedMessages?: string[];
  readonly onOk: () => void;
}

export function ErrorPopup({ dialogRef, errorMessage, detailedMessages = [], onOk }: ErrorPopupProps) {
  useEffect(() => {
    const dialog = dialogRef.current;
    if (dialog && !dialog.open) {
      dialog.showModal();
    }
  }, [dialogRef]);

  return (
    <dialog ref={dialogRef} className={styles.popupOverlay} aria-labelledby="docuparser-error-title" aria-modal="true">
      <div className={styles.popupModal}>
        <div className={styles.popupIcon} aria-hidden="true">
          <svg width="40" height="40" viewBox="0 0 62 62" fill="none">
            <circle cx="30" cy="30" r="30" fill="#e74c3c" />
            <path d="M30 20V32" stroke="white" strokeWidth="4" strokeLinecap="round" />
            <circle cx="30" cy="40" r="2" fill="white" />
          </svg>
        </div>
        <h3 id="docuparser-error-title" className={styles.popupTitle}>
          Upload Failed
        </h3>
        <p className={styles.popupMessage}>{errorMessage}</p>
        {detailedMessages.length > 0 && (
          <ul className={styles.popupDetailedMessages} aria-label="Error details">
            {detailedMessages.map((msg) => (
              <li key={msg} className={styles.popupDetailedMessage}>
                {msg}
              </li>
            ))}
          </ul>
        )}
        <div className={styles.popupButtons}>
          <button type="button" className={styles.popupBtnOk} onClick={onOk} aria-label="Close error message">
            OK
          </button>
        </div>
      </div>
    </dialog>
  );
}
